module.exports = __webpack_public_path__ + "media/images/microbius-logo-7bf7af4a965a3957b389724b7f3d2797.png";